import { render, staticRenderFns } from "./Inputr.vue?vue&type=template&id=54782e8d&"
import script from "./Inputr.vue?vue&type=script&lang=js&"
export * from "./Inputr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports